"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Benchmark = function Benchmark(props) {
  var _props$data = props.data,
    sessionsMetBenchmark = _props$data.sessionsMetBenchmark,
    totalSessions = _props$data.totalSessions;
  var colors = props.colors;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper,
    style: colors ? {
      color: colors.primary
    } : {}
  }, sessionsMetBenchmark, " out of ", totalSessions);
};
var _default = exports["default"] = Benchmark;